<template>
  <div id="requestauth">Redirecting to Your SAML2 Provider...</div>
</template>

<script>
import AuthenticationService from '@/services/api/authentication/authentication-service';
import { mapGetters } from 'vuex';
export default {
  name: 'RequestAuth',
  computed: {
    ...mapGetters(['authMethods']),
    syncguid() {
      return this.$route.params.syncguid;
    },
    authMethod() {
      if (!this.authMethods || this.authMethods.length === 0) {
        return false;
      }
      return this.authMethods.find(am => am.syncguid === this.syncguid);
    },
  },
  mounted() {
    AuthenticationService.getSAML2AuthenticationLink({
      syncguid: this.syncguid,
      redirect: this.$route.query.redirect || undefined,
      session: localStorage.getItem('session'),
    }).then(res => {
      window.location.href = res;
    });
  },
};
</script>

<style lang="less" scoped>
#requestauth {
  width: 100vw;
  height: 100vh;
  background-color: #221d24;
  color: #fff;

  form {
    display: none;
  }
}
</style>
